import { useContext, useState } from 'react'
import { ProjectListViewContext } from '../../Context'
import { useProjectStore } from 'Store/Project'
import moment from 'moment'
import { shallow } from 'zustand/shallow'

const ViewModel = () => {
  const { isOpenExportDailyReportModal, toggleExportDailyReportModal } =
    useContext(ProjectListViewContext)
  const { exportDailyReportByDate } = useProjectStore(
    state => ({ exportDailyReportByDate: state.exportDailyReportByDate }),
    shallow
  )

  const [reportDate, setReportDate] = useState<moment.Moment | null>(null)
  const [dateError, setDateError] = useState('')
  const [apiError, setApiError] = useState('')
  const [isExporting, setIsExporting] = useState(false)

  const resetState = () => {
    setReportDate(null)
    setDateError('')
    setApiError('')
    setIsExporting(false)
  }

  const handleClose = () => {
    if (isExporting) {
      return
    }
    toggleExportDailyReportModal(false)
    resetState()
  }

  const handleDateChange = (value: moment.Moment | string) => {
    if (!value || typeof value === 'string') {
      setReportDate(null)
      setDateError('กรุณาเลือกวันที่')
      return
    }

    setReportDate(value)
    setDateError('')
    setApiError('')
  }

  const handleConfirm = () => {
    if (!reportDate || !moment(reportDate).isValid()) {
      setDateError('กรุณาเลือกวันที่')
      return
    }

    setIsExporting(true)
    setApiError('')

    const formattedDate = moment(reportDate).format('YYYY-MM-DD')

    exportDailyReportByDate(formattedDate).then(({ success, data }) => {
      setIsExporting(false)

      if (success) {
        toggleExportDailyReportModal(false)
        resetState()
        return
      }

      setApiError(data)
    })
  }

  const modalsRoot = document.getElementById('root-modals') || document.body
  const isConfirmDisabled = isExporting || !reportDate || !moment(reportDate).isValid()

  return {
    modalsRoot,
    isOpenExportDailyReportModal,
    reportDate,
    dateError,
    apiError,
    isExporting,
    isConfirmDisabled,
    handleClose,
    handleDateChange,
    handleConfirm,
  }
}

export default ViewModel
